import { useTheme } from "./useTheme";

export const useChartsColors = () => {
  const { isDarkMode } = useTheme();
  
  const lightColors = '#f3f4f6'; // Tailwind gray-100
  const darkColors = '#2a2a2a'; // Dark gray for dark mode
  
  return isDarkMode ? darkColors : lightColors;
}